import * as tslib_1 from "tslib";
import { OnInit, OnChanges, TemplateRef, EventEmitter } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { LoaderService } from 'src/app/loader.service';
import { AlertDialogService } from 'src/app/shared/alert-dialog/alert-dialog.service';
import { SharedService } from 'src/app/shared/shared.service';
import { Toaster, ToasterType } from 'src/app/shared/types/toaster.types';
import { ToasterService } from 'src/app/toaster.service';
import { SubscriptionService } from '../../subscription.service';
import { environment } from 'src/environments/environment';
import Utils from 'src/app/utils/utils';
import { MatDialog } from '@angular/material';
import { AuthService } from 'src/app/auth.service';
import { ruleTypeLabel as labelForRuleType } from '../../subscription.applicable-types';
import { subscriptionCreateSuccessAlert, subscriptionOperationFailureAlert } from '../../subscription.create-alert';
var CreateSubscriptionComponent = /** @class */ (function () {
    function CreateSubscriptionComponent(sharedService, subsService, loader, alertService, toasterService, dialog, authService) {
        var _this = this;
        this.sharedService = sharedService;
        this.subsService = subsService;
        this.loader = loader;
        this.alertService = alertService;
        this.toasterService = toasterService;
        this.dialog = dialog;
        this.authService = authService;
        this.subscriptionTypes = ["REGULAR", "CASHBACK"];
        this.selectedSubscriptionType = "REGULAR";
        this.hasCashbackPermission = false;
        this.context = null;
        this.feedbackContextRequest = 0;
        this.selectorRequest = 0;
        this.qualityContextKey = '';
        this.qualityContextReady = false;
        this.feedbackContexts = [];
        this.feedbackContextsLoading = false;
        this.feedbackContextsError = false;
        this.feedbackScoreApplicability = new FormArray([this.createFeedbackEntry()]);
        this.launch = null;
        this.launchServiceUnavailable = new EventEmitter();
        this.launchConsumed = new EventEmitter();
        this.subscriptionFormGroup = new FormGroup({
            ruleName: new FormControl(null),
            city: new FormControl(null),
            services: new FormControl(null),
            userSelector: new FormControl(null),
            priority: new FormControl(null),
            startDate: new FormControl(null),
            endDate: new FormControl(null),
            excludeIncentiveTypes: new FormControl(null),
            ruleType: new FormControl(null),
            ruleValue: new FormControl(0),
            isAutoAssignedToHH: new FormControl(false),
            isAutoAssignedToMC: new FormControl(false),
            isDefaultSubscription: new FormControl(false),
            suspendServicesPostExpiry: new FormControl(false),
            targetSegment: new FormControl('userSelectors'),
            rules: new FormControl([])
        });
        this.cities = [];
        this.services = [];
        this.userSelectors = [];
        this.incentiveTypesMap = this.sharedService.INCENTIVE_TYPES_MAP;
        this.incentiveTypes = Object.keys(this.incentiveTypesMap);
        this.validityTypes = this.getValidityTypes();
        this.maxRulesAtOnce = environment.maxRulesCreationAtOnce;
        this.today = moment().startOf("hour").toDate();
        this.tomorrowEod = moment().endOf("day").minutes(30).add(1, 'days').toDate();
        this.minEndDate = this.tomorrowEod;
        this.overlappingRules = [];
        this.Utils = Utils;
        this.subscriptionTitles = [];
        this.eligibleRuleTypes = [];
        this.disableFormControl = function (controlName) {
            _this.subscriptionFormGroup.get(controlName).setValue(null, { emitEvent: false });
            _this.subscriptionFormGroup.get(controlName).disable({ emitEvent: false });
        };
        this.enableFormControl = function (controlName) {
            _this.subscriptionFormGroup.get(controlName).enable({ emitEvent: false });
        };
        this.initializeCities();
    }
    Object.defineProperty(CreateSubscriptionComponent.prototype, "isQualityFeedbackSegment", {
        get: function () {
            return this.formValue('targetSegment') === 'qualityFeedback';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateSubscriptionComponent.prototype, "showQualityFeedbackSegment", {
        get: function () {
            return this.selectedSubscriptionType !== 'CASHBACK';
        },
        enumerable: true,
        configurable: true
    });
    CreateSubscriptionComponent.prototype.createFeedbackEntry = function () {
        return new FormGroup({
            context: new FormControl(null),
            minValue: new FormControl(null),
            maxValue: new FormControl(null)
        });
    };
    CreateSubscriptionComponent.prototype.ngOnChanges = function () {
        if (!this.context || !this.qualityContextReady) {
            return;
        }
        var key = this.getQualityContextKey();
        if (key === this.qualityContextKey) {
            return;
        }
        this.qualityContextKey = key;
        this.subscriptionFormGroup.get('userSelector').setValue(null, { emitEvent: false });
        this.userSelectors = [];
        this.applyPrepaidContext();
        this.feedbackScoreApplicability = new FormArray([this.createFeedbackEntry()]);
        this.loadFeedbackContexts();
    };
    CreateSubscriptionComponent.prototype.getQualityContextKey = function () {
        var context = this.context;
        return context ? [context.city.id, context.mode.id, context.service.id,
            context.categoryServices.map(function (service) { return service.serviceDetailId; }).join(',')].join(':') : '';
    };
    CreateSubscriptionComponent.prototype.addFeedbackEntry = function () {
        this.feedbackScoreApplicability.push(this.createFeedbackEntry());
    };
    CreateSubscriptionComponent.prototype.removeFeedbackEntry = function (index) {
        if (this.feedbackScoreApplicability.length > 1) {
            this.feedbackScoreApplicability.removeAt(index);
        }
    };
    CreateSubscriptionComponent.prototype.loadFeedbackContexts = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var requestId, response, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isQualityFeedbackSegment || !this.context) {
                            return [2 /*return*/];
                        }
                        requestId = ++this.feedbackContextRequest;
                        this.feedbackContextsLoading = true;
                        this.feedbackContextsError = false;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.subsService.getFeedbackContexts(this.context.city.id, this.context.mode.id).toPromise()];
                    case 2:
                        response = _a.sent();
                        if (requestId !== this.feedbackContextRequest) {
                            return [2 /*return*/];
                        }
                        this.feedbackContexts = (response && response.data) || [];
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        if (requestId !== this.feedbackContextRequest) {
                            return [2 /*return*/];
                        }
                        this.feedbackContextsError = true;
                        this.errorMessage('Could not load feedback contexts. Please retry.');
                        return [3 /*break*/, 5];
                    case 4:
                        if (requestId === this.feedbackContextRequest) {
                            this.feedbackContextsLoading = false;
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CreateSubscriptionComponent.prototype, "showFeedbackFields", {
        get: function () {
            var userSelector = this.subscriptionFormGroup.get('userSelector');
            return this.isQualityFeedbackSegment && userSelector.enabled
                && !!(userSelector.value && userSelector.value.id)
                && !this.formValue('isAutoAssignedToHH')
                && !this.formValue('isAutoAssignedToMC')
                && !this.formValue('isDefaultSubscription')
                && this.selectedSubscriptionType !== 'CASHBACK';
        },
        enumerable: true,
        configurable: true
    });
    CreateSubscriptionComponent.prototype.buildFeedbackScoreApplicability = function () {
        var _this = this;
        if (!this.showFeedbackFields) {
            return {};
        }
        if (this.feedbackContextsLoading || this.feedbackContextsError || !this.feedbackContexts.length) {
            throw new Error('Feedback contexts must be loaded before creating a rule');
        }
        var entries = this.feedbackScoreApplicability.value;
        if (!entries.length) {
            throw new Error('At least one feedback context is required');
        }
        var seen = new Set();
        entries.forEach(function (entry, index) {
            if (_this.feedbackContexts.indexOf(entry.context) < 0 || seen.has(entry.context)) {
                throw new Error("Select a unique feedback context for entry " + (index + 1));
            }
            seen.add(entry.context);
            // The API requires both bounds to be nonzero; ratios are at most 1.
            if (typeof entry.minValue !== 'number' || typeof entry.maxValue !== 'number'
                || !Number.isFinite(entry.minValue) || !Number.isFinite(entry.maxValue)
                || entry.minValue <= 0 || entry.maxValue > 1 || entry.minValue > entry.maxValue) {
                throw new Error("Feedback bounds must satisfy 0 < min value <= max value <= 1 for entry " + (index + 1));
            }
        });
        return { feedbackScoreApplicability: entries };
    };
    CreateSubscriptionComponent.prototype.initializeCities = function () {
        var _this = this;
        this.loader.openLoading();
        this.initReady = this.fetchCities().finally(function () { return _this.loader.closeLoading(); });
    };
    CreateSubscriptionComponent.prototype.applyLaunchQueryPrefill = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var q, cityId, serviceId, city, matched, err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        q = this.launch || { city: '', service: '' };
                        cityId = (q.city || '').trim();
                        serviceId = (q.service || '').trim();
                        if (!cityId) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.initReady];
                    case 2:
                        _a.sent();
                        city = this.cities.find(function (c) { return String(c.id) === String(cityId); });
                        if (!city) {
                            this.errorMessage('City from launch URL is not available.');
                            this.launchConsumed.emit();
                            return [2 /*return*/];
                        }
                        this.subscriptionFormGroup.get('city').setValue(city, { emitEvent: false });
                        return [4 /*yield*/, this.fetchServices()];
                    case 3:
                        _a.sent();
                        if (!serviceId) {
                            this.launchConsumed.emit();
                            return [2 /*return*/];
                        }
                        matched = (this.services || []).filter(function (s) { return String(s.id) === String(serviceId); });
                        if (!matched.length) {
                            this.launchServiceUnavailable.emit();
                            return [2 /*return*/];
                        }
                        this.subscriptionFormGroup.get('services').setValue(matched);
                        this.launchConsumed.emit();
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        console.error('Launch prefill failed', err_1);
                        this.launchConsumed.emit();
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    CreateSubscriptionComponent.prototype.resetOnchangeOf = function (controlName, toReset, cb) {
        var _this = this;
        if (cb === void 0) { cb = function () { }; }
        this.subscriptionFormGroup.get(controlName).valueChanges.subscribe(function () {
            toReset.forEach(function (control) {
                _this.subscriptionFormGroup.get(control).setValue(null);
            });
            cb();
            _this.handleSubscriptionCheckBoxFormControls();
        });
    };
    CreateSubscriptionComponent.prototype.onSubscriptionTypeChange = function (type) {
        var suspendControl = this.subscriptionFormGroup.get('suspendServicesPostExpiry');
        this.enableFormControl('userSelector');
        suspendControl.setValue(false, { emitEvent: false });
        var mode = this.validateAndGetModeForServices();
        if (this.canEnableHH(mode)) {
            this.enableFormControl('isAutoAssignedToHH');
        }
        else {
            this.disableFormControl('isAutoAssignedToHH');
        }
        if (this.canEnableMC()) {
            this.enableFormControl('isAutoAssignedToMC');
        }
        else {
            this.disableFormControl('isAutoAssignedToMC');
        }
        if (this.canEnableEntireCity()) {
            this.enableFormControl('isDefaultSubscription');
        }
        else {
            this.disableFormControl('isDefaultSubscription');
        }
        this.applyPrepaidContextFlags();
        this.applyEligibleRuleTypes();
        this.syncTargetSegmentAvailability();
    };
    CreateSubscriptionComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var permissions, modeBasedFormControlHandler;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authService.getPermissions()];
                    case 1:
                        permissions = _a.sent();
                        this.hasCashbackPermission = permissions.includes('cashback_subscription_create');
                        modeBasedFormControlHandler = function (mode) {
                            if (!_this.canEnableHH(mode)) {
                                _this.disableFormControl('isAutoAssignedToHH');
                            }
                            else {
                                _this.enableFormControl('isAutoAssignedToHH');
                            }
                            if (!_this.canEnableEntireCity()) {
                                _this.disableFormControl('isDefaultSubscription');
                            }
                            else {
                                _this.enableFormControl('isDefaultSubscription');
                            }
                            if (!_this.canEnableMC()) {
                                _this.disableFormControl('isAutoAssignedToMC');
                            }
                            else {
                                _this.enableFormControl('isAutoAssignedToMC');
                            }
                            _this.applyPrepaidContextFlags();
                            _this.applyEligibleRuleTypes();
                            _this.syncTargetSegmentAvailability();
                        };
                        this.resetOnchangeOf("city", ["services"], function () {
                            _this.services = [];
                            _this.fetchServices();
                        });
                        this.resetOnchangeOf("services", ["userSelector", "suspendServicesPostExpiry"], function () {
                            _this.userSelectors = [];
                            _this.fetchSelectors();
                            // Re-apply ruleType derived from subscription type after services reset
                            _this.onSubscriptionTypeChange(_this.selectedSubscriptionType);
                            var mode = _this.validateAndGetModeForServices();
                            modeBasedFormControlHandler(mode);
                        });
                        this.resetOnchangeOf("isAutoAssignedToMC", ["rules"], function () {
                            _this.addRule();
                            var mode = _this.validateAndGetModeForServices();
                            modeBasedFormControlHandler(mode);
                            _this.handleIsAutoAssignedToMC();
                        });
                        this.resetOnchangeOf("suspendServicesPostExpiry", ["rules"], function () {
                            _this.addRule();
                            var mode = _this.validateAndGetModeForServices();
                            modeBasedFormControlHandler(mode);
                            if (_this.formValue('isAutoAssignedToHH')) {
                                _this.handleIsAutoAssignedToHH();
                            }
                            if (_this.formValue('isDefaultSubscription')) {
                                _this.handleIsDefaultSubscription();
                            }
                        });
                        this.resetOnchangeOf("isAutoAssignedToHH", ["rules"], function () {
                            _this.addRule();
                            var mode = _this.validateAndGetModeForServices();
                            modeBasedFormControlHandler(mode);
                            _this.handleIsAutoAssignedToHH();
                        });
                        this.resetOnchangeOf("isDefaultSubscription", ["rules"], function () {
                            _this.addRule();
                            var mode = _this.validateAndGetModeForServices();
                            modeBasedFormControlHandler(mode);
                            _this.handleIsDefaultSubscription();
                        });
                        this.subscriptionFormGroup.get('isAutoAssignedToHH').disable({ emitEvent: false });
                        this.subscriptionFormGroup.get('isAutoAssignedToMC').disable({ emitEvent: false });
                        this.subscriptionFormGroup.get('isDefaultSubscription').disable({ emitEvent: false });
                        this.subscriptionFormGroup.get('suspendServicesPostExpiry').disable({ emitEvent: false });
                        this.subscriptionFormGroup.get('targetSegment').valueChanges.subscribe(function () {
                            _this.applyTargetSegment();
                        });
                        if (!this.context) return [3 /*break*/, 2];
                        this.applyPrepaidContext();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.applyLaunchQueryPrefill()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        this.qualityContextReady = true;
                        this.qualityContextKey = this.getQualityContextKey();
                        return [4 /*yield*/, this.loadFeedbackContexts()];
                    case 5:
                        _a.sent();
                        if (!this.formValue('rules') || !this.formValue('rules').length) {
                            this.addRule();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateSubscriptionComponent.prototype.blockInvalidNumberKeys = function (event) {
        if (event.key === '-' || event.key === '+' || event.key === 'e' || event.key === 'E') {
            event.preventDefault();
        }
    };
    CreateSubscriptionComponent.prototype.rejectNonPositiveAmount = function (event, control) {
        var input = event.target;
        if (input.value === '' || input.value == null) {
            return;
        }
        if (Number(input.value) <= 0) {
            control.setValue(null);
            input.value = '';
        }
    };
    CreateSubscriptionComponent.prototype.serviceLabel = function (item) {
        return item.name + (item.active ? '' : ' (inactive)');
    };
    Object.defineProperty(CreateSubscriptionComponent.prototype, "modeServicesText", {
        get: function () {
            var _this = this;
            if (!this.context || !this.context.modeServices) {
                return '';
            }
            return this.context.modeServices.map(function (service) { return _this.serviceLabel(service); }).join(', ');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateSubscriptionComponent.prototype, "showEntireCitySegment", {
        get: function () {
            return this.canEnableEntireCity();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateSubscriptionComponent.prototype, "showHHSegment", {
        get: function () {
            var mode = this.validateAndGetModeForServices();
            return this.canEnableHH(mode);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateSubscriptionComponent.prototype, "showMCSegment", {
        get: function () {
            return this.canEnableMC();
        },
        enumerable: true,
        configurable: true
    });
    CreateSubscriptionComponent.prototype.syncTargetSegmentAvailability = function () {
        var segment = this.formValue('targetSegment');
        if ((segment === 'entireCity' && !this.showEntireCitySegment)
            || (segment === 'HH' && !this.showHHSegment)
            || (segment === 'MC' && !this.showMCSegment)
            || (segment === 'qualityFeedback' && !this.showQualityFeedbackSegment)) {
            this.subscriptionFormGroup.get('targetSegment').setValue('userSelectors', { emitEvent: false });
            this.applyTargetSegment();
        }
    };
    CreateSubscriptionComponent.prototype.applyTargetSegment = function () {
        var segment = this.formValue('targetSegment') || 'userSelectors';
        var userSelector = this.formValue('userSelector');
        this.subscriptionFormGroup.get('isAutoAssignedToMC').setValue(segment === 'MC', { emitEvent: false });
        this.subscriptionFormGroup.get('isAutoAssignedToHH').setValue(segment === 'HH', { emitEvent: false });
        this.subscriptionFormGroup.get('isDefaultSubscription').setValue(segment === 'entireCity', { emitEvent: false });
        this.subscriptionFormGroup.get('rules').setValue(null);
        this.addRule();
        if (segment !== 'MC') {
            this.handleIsAutoAssignedToMC();
        }
        if (segment !== 'HH') {
            this.handleIsAutoAssignedToHH();
        }
        if (segment !== 'entireCity') {
            this.handleIsDefaultSubscription();
        }
        if (segment === 'MC') {
            this.handleIsAutoAssignedToMC();
        }
        else if (segment === 'HH') {
            this.handleIsAutoAssignedToHH();
        }
        else if (segment === 'entireCity') {
            this.handleIsDefaultSubscription();
        }
        this.handleSubscriptionCheckBoxFormControls();
        if ((segment === 'userSelectors' || segment === 'qualityFeedback') && userSelector) {
            this.subscriptionFormGroup.get('userSelector').setValue(userSelector, { emitEvent: false });
        }
        if (this.isQualityFeedbackSegment) {
            this.qualityContextKey = this.getQualityContextKey();
            this.loadFeedbackContexts();
        }
    };
    CreateSubscriptionComponent.prototype.canEnableHH = function (_mode) {
        if (!this.context) {
            return false;
        }
        var triggers = this.context.autoAssignmentTriggers || [];
        return triggers.indexOf('captainFirstTimeActivation') !== -1;
    };
    CreateSubscriptionComponent.prototype.canEnableMC = function () {
        if (!this.context) {
            return false;
        }
        var triggers = this.context.autoAssignmentTriggers || [];
        return triggers.indexOf('captainMCSignup') !== -1;
    };
    CreateSubscriptionComponent.prototype.canEnableEntireCity = function () {
        return !!(this.context && this.context.allowDefaultSubscription);
    };
    CreateSubscriptionComponent.prototype.applyPrepaidContextFlags = function () {
        if (!this.context) {
            return;
        }
        if (this.canEnableHH(null)) {
            this.enableFormControl('isAutoAssignedToHH');
        }
        else {
            this.disableFormControl('isAutoAssignedToHH');
        }
        if (this.canEnableMC()) {
            this.enableFormControl('isAutoAssignedToMC');
        }
        else {
            this.disableFormControl('isAutoAssignedToMC');
        }
        if (this.canEnableEntireCity()) {
            this.enableFormControl('isDefaultSubscription');
        }
        else {
            this.disableFormControl('isDefaultSubscription');
        }
        var suspend = this.subscriptionFormGroup.get('suspendServicesPostExpiry');
        if (this.context.alwaysSuspendServicesPostExpiry) {
            suspend.setValue(true, { emitEvent: false });
            suspend.disable({ emitEvent: false });
            return;
        }
        if (this.context.allowSuspendServicesPostExpiry) {
            suspend.enable({ emitEvent: false });
            return;
        }
        suspend.setValue(false, { emitEvent: false });
        suspend.disable({ emitEvent: false });
    };
    Object.defineProperty(CreateSubscriptionComponent.prototype, "showBlockOrders", {
        get: function () {
            if (!this.context) {
                return true;
            }
            return this.context.alwaysSuspendServicesPostExpiry === true || this.context.allowSuspendServicesPostExpiry === true;
        },
        enumerable: true,
        configurable: true
    });
    CreateSubscriptionComponent.prototype.applyPrepaidContext = function () {
        var modeId = this.context.mode && this.context.mode.id;
        var withMode = function (service) { return Object.assign({}, service, { mode: service.mode || modeId }); };
        this.subscriptionFormGroup.get('city').setValue(this.context.city, { emitEvent: false });
        if (this.context.skipServiceHierarchy) {
            this.services = (this.context.modeServices || []).map(withMode);
            this.subscriptionFormGroup.get('services').setValue(this.services, { emitEvent: false });
        }
        else {
            this.services = (this.context.categoryServices || []).map(withMode);
            var selectedId_1 = this.context.service && this.context.service.id;
            var selected = this.services.filter(function (service) { return String(service.id) === String(selectedId_1); });
            this.subscriptionFormGroup.get('services').setValue(selected.length ? selected : [withMode(this.context.service)], { emitEvent: false });
        }
        this.fetchSelectors();
        this.applyPrepaidContextFlags();
        this.applyEligibleRuleTypes();
        this.applyDisplayTitles();
        this.syncTargetSegmentAvailability();
    };
    CreateSubscriptionComponent.prototype.ruleTypeLabel = function (type) {
        return labelForRuleType(type);
    };
    Object.defineProperty(CreateSubscriptionComponent.prototype, "isRuleTypeLocked", {
        get: function () {
            return this.eligibleRuleTypes.length === 1;
        },
        enumerable: true,
        configurable: true
    });
    CreateSubscriptionComponent.prototype.applyEligibleRuleTypes = function () {
        var types = (this.context && this.context.eligibleRuleTypes) || [];
        this.eligibleRuleTypes = types.length ? types : ['zeroCommission'];
        var current = this.subscriptionFormGroup.get('ruleType').value;
        if (this.eligibleRuleTypes.indexOf(current) === -1) {
            this.subscriptionFormGroup.get('ruleType').setValue(this.eligibleRuleTypes[0], { emitEvent: false });
        }
        if (this.eligibleRuleTypes.length === 1) {
            this.subscriptionFormGroup.get('ruleType').disable({ emitEvent: false });
        }
        else {
            this.subscriptionFormGroup.get('ruleType').enable({ emitEvent: false });
        }
    };
    CreateSubscriptionComponent.prototype.applyDisplayTitles = function () {
        var titles = (this.context && this.context.displayTitles) || [];
        this.subscriptionTitles = Array.isArray(titles) ? titles : [];
    };
    Object.defineProperty(CreateSubscriptionComponent.prototype, "taxInfoText", {
        get: function () {
            return this.context && this.context.exclusiveOfTax
                ? 'This amount is exclusive of tax'
                : 'This amount is inclusive of tax';
        },
        enumerable: true,
        configurable: true
    });
    CreateSubscriptionComponent.prototype.handleIsDefaultSubscription = function () {
        if (!this.formValue('isDefaultSubscription')) {
            this.maxRulesAtOnce = environment.maxRulesCreationAtOnce;
            this.subscriptionFormGroup.get('endDate').enable({ emitEvent: false });
            this.subscriptionFormGroup.get('userSelector').enable({ emitEvent: false });
            this.subscriptionFormGroup.get('priority').setValue(null, { emitEvent: false });
            this.subscriptionFormGroup.get('priority').enable({ emitEvent: false });
        }
        else {
            this.maxRulesAtOnce = environment.maxRulesCreationAtOnce;
            this.subscriptionFormGroup.get('endDate').setValue(null, { emitEvent: false });
            this.subscriptionFormGroup.get('endDate').disable({ emitEvent: false });
            this.disableFormControl('userSelector');
            this.subscriptionFormGroup.get('priority').setValue(0, { emitEvent: false });
            this.subscriptionFormGroup.get('priority').disable({ emitEvent: false });
        }
    };
    CreateSubscriptionComponent.prototype.handleIsAutoAssignedToMC = function () {
        if (this.formValue('isAutoAssignedToMC')) {
            this.maxRulesAtOnce = 1;
            this.disableFormControl('endDate');
            this.disableFormControl('userSelector');
            this.disableFormControl('priority');
            this.disableFormControl('excludeIncentiveTypes');
            this.subscriptionFormGroup.get('rules').value.map(function (rule) {
                rule.periodInDays.setValue(null, { emitEvent: false });
                rule.periodInDays.disable({ emitEvent: false });
                rule.ruleAmount.setValue(0, { emitEvent: false });
                rule.ruleAmount.disable({ emitEvent: false });
            });
        }
        else {
            this.enableFormControl('endDate');
            this.enableFormControl('priority');
            this.enableFormControl('excludeIncentiveTypes');
            this.enableFormControl('userSelector');
        }
    };
    CreateSubscriptionComponent.prototype.handleIsAutoAssignedToHH = function () {
        if (!this.formValue('isAutoAssignedToHH')) {
            this.maxRulesAtOnce = environment.maxRulesCreationAtOnce;
            this.subscriptionFormGroup.get('endDate').enable({ emitEvent: false });
            this.subscriptionFormGroup.get('userSelector').enable({ emitEvent: false });
        }
        else {
            this.maxRulesAtOnce = 1;
            this.subscriptionFormGroup.get('endDate').setValue(null, { emitEvent: false });
            this.subscriptionFormGroup.get('endDate').disable({ emitEvent: false });
            this.disableFormControl('userSelector');
            this.subscriptionFormGroup.get('rules').value.map(function (rule) {
                rule.ruleAmount.setValue(0, { emitEvent: false });
                rule.ruleAmount.disable({ emitEvent: false });
            });
        }
    };
    CreateSubscriptionComponent.prototype.handleSubscriptionCheckBoxFormControls = function () {
        if (!this.services) {
            this.disableFormControl('isAutoAssignedToMC');
            this.disableFormControl('isAutoAssignedToHH');
            this.disableFormControl('isDefaultSubscription');
            this.disableFormControl('suspendServicesPostExpiry');
        }
        if (this.formValue("isDefaultSubscription")) {
            this.disableFormControl('isAutoAssignedToMC');
            this.disableFormControl('isAutoAssignedToHH');
        }
        if (this.formValue("isAutoAssignedToHH")) {
            this.disableFormControl('isAutoAssignedToMC');
            this.disableFormControl('isDefaultSubscription');
        }
        if (this.formValue("isAutoAssignedToMC")) {
            this.disableFormControl('isAutoAssignedToHH');
            this.disableFormControl('isDefaultSubscription');
            this.disableFormControl('suspendServicesPostExpiry');
        }
        if (this.formValue("suspendServicesPostExpiry")) {
            this.disableFormControl('isAutoAssignedToMC');
        }
    };
    CreateSubscriptionComponent.prototype.formValue = function (name) {
        return this.subscriptionFormGroup.get(name).value;
    };
    CreateSubscriptionComponent.prototype.fetchSelectors = function () {
        var _this = this;
        var requestId = ++this.selectorRequest;
        this.userSelectors = [];
        var city = this.formValue("city");
        var services = this.formValue("services");
        if (city && services) {
            var serviceTypes = services
                .map(function (s) { return s.serviceDetailId; }).join(",");
            this.loader.openLoading();
            this.sharedService
                .fetchRules(city.id, serviceTypes, null, "rider")
                .toPromise()
                .then(function (res) {
                if (requestId !== _this.selectorRequest) {
                    return;
                }
                _this.userSelectors = res.data.selectors
                    .map(function (_a) {
                    var _id = _a._id, name = _a.name;
                    return ({ id: _id, name: name });
                });
            })
                .finally(function () { return _this.loader.closeLoading(); });
        }
    };
    CreateSubscriptionComponent.prototype.fetchServices = function () {
        var _this = this;
        var city = this.formValue("city");
        if (!city) {
            return Promise.resolve();
        }
        this.loader.openLoading();
        return this.sharedService
            .fetchServicesWithMode(city.id)
            .toPromise()
            .then(function (res) {
            _this.services = res.data
                .filter(function (serviceDetail) { return serviceDetail.active; })
                .map(function (_a) {
                var service = _a.service, _id = _a._id, modeInfo = _a.modeInfo;
                return ({
                    id: service._id,
                    name: service.name,
                    mode: modeInfo._id,
                    serviceDetailId: _id
                });
            });
        })
            .finally(function () { return _this.loader.closeLoading(); });
    };
    CreateSubscriptionComponent.prototype.fetchCities = function () {
        var _this = this;
        return this.sharedService
            .fetchCities()
            .toPromise()
            .then(function (res) {
            _this.cities = res.data.cities
                .map(function (_a) {
                var _id = _a._id, displayName = _a.displayName;
                return ({ id: _id, name: displayName });
            });
        });
    };
    CreateSubscriptionComponent.prototype.changeInDate = function () {
        var startDate = this.formValue("startDate");
        if (startDate) {
            this.minEndDate = startDate;
        }
        var endDate = this.formValue("endDate");
        if (endDate) {
            this.maxStartDate = endDate;
        }
    };
    CreateSubscriptionComponent.prototype.createSubscriptionRules = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var rules, payload, resp, error_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loader.openLoading();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, 5, 6]);
                        return [4 /*yield*/, this.buildRules()];
                    case 2:
                        rules = _a.sent();
                        if (!rules) {
                            return [2 /*return*/];
                        }
                        payload = {
                            type: this.formValue('isAutoAssignedToMC') ? "MC" : this.selectedSubscriptionType,
                            rules: rules,
                        };
                        return [4 /*yield*/, this.subsService.createSubscriptionRules(payload).toPromise()];
                    case 3:
                        resp = _a.sent();
                        this.alertService.open(subscriptionCreateSuccessAlert(resp, { configRequestKind: 'subscription' }));
                        return [3 /*break*/, 6];
                    case 4:
                        error_2 = _a.sent();
                        this.alertService.open(subscriptionOperationFailureAlert(error_2));
                        return [3 /*break*/, 6];
                    case 5:
                        this.loader.closeLoading();
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    CreateSubscriptionComponent.prototype.alertMessage = function (alert) {
        this.alertService.open(alert);
    };
    CreateSubscriptionComponent.prototype.errorMessage = function (message) {
        this.toasterService.showToaster(new Toaster({
            type: ToasterType.WARNING,
            message: message
        }));
    };
    CreateSubscriptionComponent.prototype.validateField = function (fieldName, message) {
        var value = this.formValue(fieldName);
        if (!value) {
            this.errorMessage(message);
            throw new Error(message);
        }
        return value;
    };
    CreateSubscriptionComponent.prototype.buildRules = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var feedbackFields, ruleName, city, services, mode, isAutoAssignedToHH, isAutoAssignedToMC, isDefaultSubscription, suspendServicesPostExpiry, startTime, endTime, skipUserSelector, userSelector, excludeIncentiveTypes, ruleType, ruleValue, serviceDetailIds, priority, recommendedCount, rules, error_3, rules, higherPriorityRules, rules, commonFields;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        feedbackFields = this.buildFeedbackScoreApplicability();
                        ruleName = this.validateField("ruleName", "Rule name is required");
                        city = this.validateField("city", "City is required");
                        services = this.validateField("services", "Services is required");
                        mode = this.validateAndGetModeForServices();
                        isAutoAssignedToHH = this.formValue('isAutoAssignedToHH');
                        isAutoAssignedToMC = this.formValue('isAutoAssignedToMC');
                        isDefaultSubscription = this.formValue('isDefaultSubscription');
                        suspendServicesPostExpiry = this.selectedSubscriptionType === 'CASHBACK' || this.formValue('suspendServicesPostExpiry');
                        startTime = moment(this.validateField("startDate", "Purchase Start date is required").getTime()).unix();
                        endTime = !(isAutoAssignedToHH || isAutoAssignedToMC || isDefaultSubscription) ? moment(this.validateField("endDate", "Purchase  End date is required").getTime()).unix() : null;
                        skipUserSelector = isAutoAssignedToHH || isAutoAssignedToMC || isDefaultSubscription || this.selectedSubscriptionType === 'CASHBACK';
                        userSelector = !skipUserSelector ? this.validateField("userSelector", "User selector is required") : null;
                        excludeIncentiveTypes = this.formValue("excludeIncentiveTypes");
                        ruleType = this.validateField("ruleType", "Rule type is required");
                        ruleValue = this.formValue("ruleValue") || 0;
                        serviceDetailIds = services.map(function (s) { return s.serviceDetailId; });
                        priority = null;
                        if (isAutoAssignedToMC) {
                            priority = null;
                        }
                        else if (isDefaultSubscription) {
                            priority = 0;
                        }
                        else {
                            priority = this.validateField("priority", "Priority is required");
                        }
                        if (this.formValue('rules').length < 1) {
                            this.errorMessage("At least one rule is required");
                        }
                        recommendedCount = this.countRecommendedRules();
                        if (recommendedCount > 1) {
                            this.errorMessage("Only one rule with Recommended tag is allowed");
                            this.alertMessage({
                                title: "Error",
                                message: "Only one rule with Recommended tag is allowed",
                            });
                            return [2 /*return*/];
                        }
                        if (!!(isAutoAssignedToHH || isAutoAssignedToMC || isDefaultSubscription)) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.subsService.getSamePriorityRules(serviceDetailIds, startTime, endTime, [priority]).toPromise()];
                    case 2:
                        rules = _a.sent();
                        if (rules && rules.length > 0) {
                            this.overlappingRules = rules;
                            this.dialog.open(this.OverlappingPriorityRuleAlert);
                            return [2 /*return*/];
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        this.alertMessage({
                            title: "Error",
                            message: JSON.stringify(error_3.message),
                        });
                        return [2 /*return*/];
                    case 4:
                        if (!isAutoAssignedToHH) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.subsService.getHighestPriorityHHRule(serviceDetailIds).toPromise()];
                    case 5:
                        rules = _a.sent();
                        higherPriorityRules = rules.filter(function (rule) { return rule.priority >= priority; });
                        if (higherPriorityRules.length > 0) {
                            this.overlappingRules = higherPriorityRules;
                            this.dialog.open(this.OverlappingPriorityRuleAlert);
                            return [2 /*return*/];
                        }
                        _a.label = 6;
                    case 6:
                        if (!isDefaultSubscription) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.subsService.getHighestPriorityDefaultRule(serviceDetailIds).toPromise()];
                    case 7:
                        rules = _a.sent();
                        if (rules.some(function (rule) { return rule.priority >= priority; })) {
                            this.overlappingRules = rules;
                            this.dialog.open(this.OverlappingPriorityRuleAlert);
                            return [2 /*return*/];
                        }
                        _a.label = 8;
                    case 8:
                        commonFields = tslib_1.__assign({}, feedbackFields, { ruleName: ruleName, startTime: startTime, endTime: endTime, priority: !isAutoAssignedToMC ? Number(priority) : 0, city: city.id, services: services.map(function (s) { return s.id; }), serviceDetails: serviceDetailIds, mode: mode,
                            isAutoAssignedToHH: isAutoAssignedToHH,
                            isAutoAssignedToMC: isAutoAssignedToMC,
                            isDefaultSubscription: isDefaultSubscription, exclusiveOfTax: !!(this.context && this.context.exclusiveOfTax), userSelectors: !skipUserSelector ? [userSelector.id] : [], userSelectorName: !skipUserSelector ? userSelector.name : null, excludeIncentiveTypes: excludeIncentiveTypes || [], ruleType: ruleType,
                            suspendServicesPostExpiry: suspendServicesPostExpiry, rule: [this.getRuleConstruct(ruleType, ruleValue)] });
                        return [2 /*return*/, this.formValue('rules').map(function (rule, index) {
                                if (!rule.validityType.value) {
                                    _this.errorMessage("validity type is required for rule " + (index + 1));
                                    throw new Error("validity type is required for rule " + (index + 1));
                                }
                                if (rule.validityType.value === 'dapr' && !rule.minValue.value) {
                                    _this.errorMessage("min value is required for dapr validity in rule " + (index + 1));
                                    throw new Error("min value is required for dapr validity in rule " + (index + 1));
                                }
                                if (!rule.maxValue.value && rule.validityType.value !== 'unlimited' && rule.validityType.value !== 'dapr') {
                                    _this.errorMessage("max value is required for rule " + (index + 1));
                                    throw new Error("max value is required for rule " + (index + 1));
                                }
                                var isAutoAssigned = isAutoAssignedToHH || isAutoAssignedToMC;
                                if (!isAutoAssigned && rule.ruleAmount.value <= 0) {
                                    _this.errorMessage("purchase price is required and must have a value greater than zero for rule " + (index + 1));
                                    throw new Error("purchase price is required and must have a value greater than zero for rule " + (index + 1));
                                }
                                if (isAutoAssigned && rule.ruleAmount.value < 0) {
                                    _this.errorMessage("invalid purchase price for rule " + (index + 1));
                                    throw new Error("invalid purchase price for rule " + (index + 1));
                                }
                                if (rule.strikedOutAmount.value && rule.strikedOutAmount.value <= rule.ruleAmount.value) {
                                    _this.errorMessage("Original price should be greater than purchase price for rule " + (index + 1));
                                    throw new Error("Original price should be greater than purchase price for rule " + (index + 1));
                                }
                                if (!isAutoAssignedToMC && !rule.periodInDays.value) {
                                    _this.errorMessage("period in days is required for rule " + (index + 1));
                                    throw new Error("period in days is required for rule " + (index + 1));
                                }
                                var validityObj = { type: rule.validityType.value };
                                if (rule.maxValue.value != null && rule.maxValue.value !== '') {
                                    validityObj.maxValue = rule.maxValue.value;
                                }
                                if (rule.minValue.value != null && rule.minValue.value !== '') {
                                    validityObj.minValue = rule.minValue.value;
                                }
                                return tslib_1.__assign({}, commonFields, { validity: [validityObj], ruleAmount: rule.ruleAmount.value, strikedOutAmount: rule.strikedOutAmount.value, periodInDays: rule.periodInDays.value, ruleTitle: rule.subscriptionTitle.value, isRecommended: rule.isRecommended.value || false });
                            })];
                }
            });
        });
    };
    CreateSubscriptionComponent.prototype.getRuleConstruct = function (ruleType, ruleValue) {
        switch (ruleType) {
            case "variableCommission":
                var value = Number(ruleValue);
                if (!value || value > 100) {
                    var message = "Rule value should be between 0 to 100";
                    this.errorMessage(message);
                    throw new Error(message);
                }
                return {
                    variable: "commission",
                    operator: "-",
                    value: value,
                    type: "percent"
                };
            case "zeroCommission":
            case "qualityReset":
                return {
                    variable: "commission",
                    operator: "=",
                    value: 0,
                    type: "flat"
                };
        }
    };
    CreateSubscriptionComponent.prototype.addRule = function () {
        var defaultRuleElement = {
            validityType: new FormControl(null),
            maxValue: new FormControl(null),
            minValue: new FormControl(null),
            ruleAmount: new FormControl(null),
            strikedOutAmount: new FormControl(null),
            periodInDays: new FormControl(null),
            subscriptionTitle: new FormControl(null),
            isRecommended: new FormControl(false)
        };
        if (this.formValue('rules')) {
            this.formValue('rules').push(defaultRuleElement);
        }
        else {
            this.subscriptionFormGroup.get('rules').setValue([defaultRuleElement]);
        }
    };
    CreateSubscriptionComponent.prototype.countRecommendedRules = function () {
        var rulesArray = this.subscriptionFormGroup.get('rules').value;
        var recommendTag = 0;
        rulesArray.forEach(function (element, index) {
            if (element.isRecommended.value) {
                recommendTag++;
            }
        });
        return recommendTag;
    };
    CreateSubscriptionComponent.prototype.deleteRule = function (index) {
        this.formValue('rules').splice(index, 1);
    };
    CreateSubscriptionComponent.prototype.validityTypeChanged = function (rule) {
        if (rule.validityType.value === 'unlimited') {
            rule.maxValue.setValue(null);
            rule.maxValue.disable();
            rule.minValue.setValue(null);
            rule.minValue.disable();
        }
        else if (rule.validityType.value === 'dapr') {
            rule.maxValue.setValue(null);
            rule.maxValue.disable();
            rule.minValue.enable();
        }
        else {
            rule.maxValue.enable();
            rule.minValue.setValue(null);
            rule.minValue.disable();
        }
    };
    CreateSubscriptionComponent.prototype.validateAndGetModeForServices = function () {
        if (!this.formValue('services')) {
            return;
        }
        var distinctModes = new Set(this.formValue('services').map(function (service) { return service.mode; }));
        if (distinctModes.size > 1) {
            this.subscriptionFormGroup.get('services').setValue(null);
            this.subscriptionFormGroup.get('ruleType').setValue(null);
            this.alertMessage({
                title: "Error",
                message: "Please select services with same mode"
            });
            return;
        }
        var mode = distinctModes.values().next().value;
        return mode;
    };
    CreateSubscriptionComponent.prototype.getValidityTypes = function () {
        return environment.validityTypesEnabled.length > 0 ? environment.validityTypesEnabled : ["unlimited"];
    };
    CreateSubscriptionComponent.prototype.getValidityTypesForSelectedType = function () {
        if (this.selectedSubscriptionType === 'CASHBACK' || this.formValue('ruleType') === 'qualityReset') {
            return ['dapr'];
        }
        return this.validityTypes.filter(function (type) { return type !== 'dapr'; });
    };
    return CreateSubscriptionComponent;
}());
export { CreateSubscriptionComponent };
